<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div
            class="modal-close grow"
            @click="$store.commit('hideSubmitReviewLink')"
          >
            <i class="material-icons">close</i>
          </div>
          <div class="modal-title">Submit a Review Link</div>
          <div class="form-content">
            <div v-if="lockActionInProgress">
              <v-layout row justify-center>
                <div class="extra-instructions centered">
                  <div class="extra-instructions-item" v-if="error">
                    Making those changes and approving your review...
                  </div>
                  <div class="extra-instructions-item" v-else>
                    We're checking the link you submitted...
                  </div>
                  <div class="loader-container">
                    <div class="loader"></div>
                  </div>
                </div>
              </v-layout>
            </div>
            <div v-else>
              <v-layout>
                <div v-if="error" class="extra-instructions">
                  <div
                    class="extra-instructions-item"
                    v-html="parsedHTML"
                  ></div>
                  <div v-if="error.correctable">
                    <div v-if="error.type.includes('amazon_username')">
                      <v-layout justify-center row wrap>
                        <div class="choice-contaner">
                          <div class="checkbox-label-bold">
                            <div
                              class="choice"
                              :class="{ 'choice-reject': !updateUsername }"
                              @click="setUpdateUsernameChoice(false)"
                            >
                              Keep My Reviewer Name
                            </div>
                            <label class="switch">
                              <input type="checkbox" v-model="updateUsername" />
                              <div class="slider round"></div>
                            </label>
                            <div
                              class="choice"
                              :class="{ 'choice-confirm': updateUsername }"
                              @click="setUpdateUsernameChoice(true)"
                            >
                              Update Reviewer Name
                            </div>
                          </div>
                        </div>
                      </v-layout>
                    </div>
                    <div v-if="error.type.includes('country_code')">
                      <v-layout justify-center row wrap>
                        <div class="choice-contaner">
                          <div class="checkbox-label-bold">
                            <div
                              class="choice"
                              :class="{ 'choice-reject': !updateCountry }"
                              @click="setUpdateCountryChoice(false)"
                            >
                              Keep My Country
                            </div>
                            <label class="switch">
                              <input type="checkbox" v-model="updateCountry" />
                              <div class="slider round"></div>
                            </label>
                            <div
                              class="choice"
                              :class="{ 'choice-confirm': updateCountry }"
                              @click="setUpdateCountryChoice(true)"
                            >
                              Update Country
                            </div>
                          </div>
                        </div>
                      </v-layout>
                    </div>
                  </div>
                </div>
                <div v-else class="extra-instructions">
                  <div class="extra-instructions-item">
                    If you do not see your review on Amazon, please try
                    resubmitting your review as soon as you can!
                  </div>
                  <div class="extra-instructions-item">
                    If you see your review on Amazon, please follow these steps
                    to send us your review's direct link:
                    <ol>
                      <li>Find your review on Amazon</li>
                      <li>Right click the bold title of your review</li>
                      <li>Click 'copy link address'</li>
                      <li>
                        Paste the link to your review from Amazon below and
                        we'll go take a look and see if we <br />can verify
                        everything for you!
                      </li>
                    </ol>
                  </div>
                  <label class="extra-instructions-label"
                    >Direct Amazon Review Link:
                  </label>
                  <input type="text" class="input-box" v-model="review_url" />
                  <label class="error-message">{{ urlValidationError }}</label>
                </div>
              </v-layout>
              <v-layout row justify-center>
                <div
                  class="actions"
                  :class="{ 'action-in-progress': lockActionInProgress }"
                >
                  <button
                    class="action turn-in-action"
                    :class="{ cancel: invalidSubmission }"
                    :disabled="invalidSubmission"
                    @click="clickAction()"
                  >
                    {{ action }}
                  </button>
                </div>
              </v-layout>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Back from "@/modules/Back";
import Bus from "../../modules/Bus";
import { mapGetters } from "vuex";

export default {
  name: "ReviewLinkSubmission",
  components: {},
  props: ["assignment"],
  emits: ["close"],
  data: function () {
    return {
      showModal: false,
      review_url: null,
      submittedLink: false,
      lockActionInProgress: false,
      error: null,
      updateUsername: true,
      updateCountry: false,
      urlValidationError: null,
    };
  },
  async beforeMount() {},
  mounted() {},
  computed: {
    ...mapGetters({
      user: "user",
      allowedCountries: "allowedCountries",
    }),
    action() {
      if (!this.error) {
        return "Submit";
      } else if (this.error.type === "not_found") {
        return "Try Again";
      } else if (!this.error.correctable || !this.updateUsername) {
        return "My Profile";
      } else {
        return "Confirm";
      }
    },
    parsedHTML() {
      if (!this.error || !this.error.message) {
        return "";
      }
      return this.error.message.replace(
        /class=title-text/g,
        'style="font-size: 14pt; font-weight: 700; color:#1992f3;"'
      );
    },
    invalidSubmission() {
      if (!this.submittedLink && !this.urlValidationError) {
        return false;
      } else if (this.urlValidationError == "No link provided!") {
        this.urlValidationError = null;
        return false;
      } else if (!this.review_url) {
        this.urlValidationError = "No link provided!";
        this.submittedLink = false;
        return true;
      } else {
        if (!isValidReviewLink(this.review_url)) {
          this.urlValidationError =
            "The link you entered doesn't look like a direct link to an amazon review!";
          return true;
        } else {
          this.urlValidationError = null;
          return false;
        }
      }
    },
  },
  methods: {
    toggle() {
      this.showModal = !this.showModal;
    },
    setUpdateCountryChoice(boolean) {
      this.updateCountry = boolean;
    },
    setUpdateUsernameChoice(boolean) {
      this.updateUsername = boolean;
    },
    clickCancel() {
      this.showModal = false;
      this.lockActionInProgress = false;
      this.review_url = null;
      this.error = null;
      this.urlValidationError = null;
      this.submittedLink = false;
      this.updateUsername = true;
      this.updateCountry = false;
    },
    clickAction() {
      switch (this.action) {
        case "My Profile":
          window.location.href = process.env.VUE_APP_ACCOUNT_URL + "/settings";
          break;
        case "Try Again":
          this.lockActionInProgress = false;
          this.review_url = null;
          this.error = null;
          this.urlValidationError = null;
          this.submittedLink = false;
          break;
        case "Confirm":
          this.reconcileReview();
          break;
        default:
          if (this.urlValidationError == "No link provided!") {
            this.urlValidationError = null;
          } else {
            this.submittedLink = true;
          }
          if (
            !this.urlValidationError &&
            this.review_url &&
            isValidReviewLink(this.review_url)
          ) {
            this.submitReviewLink();
          }
      }
    },
    async submitReviewLink() {
      this.lockActionInProgress = true;
      await Back.submitReviewLink({
        review_url: this.review_url,
        assignment_id: this.assignment.id,
      }).then((response) => {
        this.lockActionInProgress = false;
        // console.log("submitResponse: ", response);
        if (!response) {
          this.showFailureMessage(
            "Opps, something went wrong! Please try again later."
          );
          this.showModal = false;
        } else if (response.error) {
          if (response.type === "approval") {
            this.showFailureMessage(response.message);
            this.clickCancel;
          } else {
            this.error = response;
          }
        } else {
          this.showSuccessMessage("Your review has been approved!");
          Bus.$emit("UserChanged");
          this.showModal = false;
        }
      });
    },
    async reconcileReview() {
      this.lockActionInProgress = true;
      await Back.reconcileReview({
        id: this.error.reconcile_id,
        update_country: this.updateCountry,
      }).then((response) => {
        this.lockActionInProgress = false;
        // console.log("reconcileResponse: ", response);
        if (!response) {
          this.showFailureMessage(
            "Opps, something went wrong! Please try again later."
          );
          this.showModal = false;
        } else if (response.error) {
          this.showFailureMessage(response.message);
          this.showModal = false;
        } else {
          if (
            this.error.type.includes("amazon_username") ||
            this.updateCountry
          ) {
            this.showSuccessMessage(
              "Your review has been approved and your profile updated!"
            );
          } else {
            this.showSuccessMessage("Your review has been approved!");
          }
          Bus.$emit("UserChanged");
          this.showModal = false;
        }
      });
    },
    showSuccessMessage(message) {
      this.$toasted.show(message, {
        icon: "check_circle",
        position: "bottom-center",
        duration: 6000,
      });
    },
    showFailureMessage(message) {
      this.$toasted.show(message, {
        icon: "cancel",
        position: "bottom-center",
        duration: 6000,
      });
    },
    showErrorMessage(message) {
      this.$toasted.show("Error: " + message, {
        icon: "error",
        position: "bottom-center",
        duration: 6000,
      });
    },
  },
};

function isValidReviewLink(text) {
  const regex = new RegExp("www\\.amazon\\..*(?<=review\\/|reviews\\/)[A-Z0-9]*(?=\\/|\\?|$)","m");
  return regex.test(text);
}
</script>

<style lang="scss" scoped>
.none {
  margin: 0 !important;
  padding: 0 !important;
}
.action {
  display: block;
}
.copy-amazon-link {
  margin: 0;
  margin-top: -6px;
  font-size: 10.5pt !important;
}

.header-text {
  text-align: center;
  // padding-left: 1em;
  color: #444;
  // font-weight: 600 !important;
  // font-size: 15.5pt !important;
  // padding-right: 2px !important;
}

.input-box {
  font-weight: normal;
  border: 1px solid #ddd;
  padding: 3px;
  margin: 0.5px, 10px, 0.5px, 10px;
  width: 95%;
}

.error-message {
  display: block;
  color: $color-red;
}

.turn-in-action {
  background: lighten(#c8e6c9, 5%) !important;
  color: #43a047 !important;
}

.choice-contaner {
  border: 3px solid #ddd;
  border-radius: 3em;
  padding: 2px 10px 2px 10px;
  margin-top: 1.5em;
}

.choice {
  opacity: 60%;
  color: #444;
  // color: $color-red;
  // background: lighten($color-red, 30%);
  margin: 2px;
  cursor: pointer;
}

.choice-confirm {
  opacity: 100%;
  color: #43a047;
}

.choice-reject {
  opacity: 100%;
  color: $color-red;
}

.selected {
  opacity: 100%;
  background: lighten(#c8e6c9, 5%);
  color: #43a047;
  -webkit-box-shadow: inset 0px 0px 0px 4px #43a047;
  -moz-box-shadow: inset 0px 0px 0px 4px #43a047;
  box-shadow: inset 0px 0px 0px 4px solid #43a047;
  margin: 2px;
}

.cancel {
  color: #999;
  background: #f2f2f2;
}

.extra-instructions {
  color: #777;
  font-size: 13pt;
  padding-left: 34px;
  width: 100%;
}

.extra-instructions-item {
  margin: auto;
  display: block;
  padding: 6px 0;
}

.extra-instructions-label {
  color: #888;
  font-size: 10pt;
}

.action-in-progress {
  box-shadow: 0 0 0.3rem rgba(0, 0, 0, 0.3);
  cursor: pointer;
  transform: scale(1.05);
  pointer-events: none;
}

.second-button {
  margin-left: 0.5em;
}

.checkbox-label {
  display: flex;
  font-size: 18px;
  align-items: center;
  padding: 10px;
}

.checkbox-label-bold {
  display: flex;
  font-weight: bold;
  font-size: 18px;
  align-items: center;
  padding: 10px;
}

.checkbox-label-modal-col {
  display: flex;
  font-size: 16px;
  align-items: center;
  padding: 5px 3px 3px 8px;

  .text {
    width: 40%;
    padding: 0;
    margin: 0 5px 0 0;
  }
}

.text {
  width: 40%;
  padding: 0;
  margin: 0 5px 0 0;
  // margin-right: 5px !important;
}

.checkbox-sublabel {
  display: flex;
  font-weight: normal;
  font-size: 15px;
  align-items: center;
  margin-left: 9.65em;
}

.switch {
  position: relative;
  display: inline-block;
  width: 80px;
  height: 34px;
  margin: 10px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  // background-color: #ccc;
  background-color: $color-red;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  // background-color: #101010;
  background-color: #43a047;
}

input:focus + .slider {
  box-shadow: 0 0 1px #101010;
}

input:checked + .slider:before {
  -webkit-transform: translateX(46px);
  -ms-transform: translateX(46px);
  transform: translateX(46px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.loader {
  margin: auto;
  border: 20px solid #eaf0f6;
  border-radius: 50%;
  border-top: 20px solid $color-blue;
  width: 100px;
  height: 100px;
  animation: spinner 3s linear infinite;
}

.loader-container {
  padding: 4em 0 6.8em;
}

.modal-title {
  padding: 0.5em;
  padding-left: 30px;
  font-size: 21pt;
  font-weight: 500;
  color: #111;
  text-align: center;
}
.modal-instructions {
  font-size: 12pt;
  color: #111;
  text-align: center;
}
.modal-limit-instructions {
  padding: 60px 120px;
  font-size: 13.5pt;
  color: #111;
  text-align: center;
}
.modal-close {
  color: black;
  font-size: 15pt;
  margin-right: 6px;
  padding: 7px 0 0 6.5px;
  width: 36px;
  height: 36px;
  border-radius: 100px;
  float: right;
  position: relative;
  transition: all 0.2s ease-in-out;
}
.modal-close:hover {
  background: #eee;
  transform: scale(1.1);
  cursor: pointer;
}

.action {
  display: block;
  margin: auto;
  background: #ede7f6;
  color: #9575cd;
}
.actions {
  text-align: center;
  padding-top: 20px;
}
.centered {
  text-align: center;
}

.confirm-text {
  padding: 0.75em 0 0 0;
  font-size: 11.5pt;
  color: #333;
  text-align: center;
}
.points-text {
  color: darken(#ffa000, 6%);
  font-weight: 700;
}
.book-title {
  color: $color-blue;
  font-weight: 700;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  z-index: 100000;
}

.modal-container {
  z-index: 999999;
  width: 800px;
  margin: 0px auto;
  padding: 20px 10px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 0 2.5rem rgba(0, 0, 0, 0.19);
  transition: all 0.3s ease;
  font-family: "Source Sans Pro";
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

@media (max-width: 1024px) {
  // .modal-mask {
  //   position: absolute !important;
  // }
  .modal-container {
    height: auto;
    width: 100%;
    max-width: 100%;
    padding: 20px 0;
  }

  .modal-title {
    text-align: left;
    font-size: 19pt;
    padding-top: 1px;
    padding-left: 18px;
    padding-right: 0;
  }

  .modal-close {
    float: right !important;
    position: initial !important;
    margin-right: 12px !important;
  }

  .modal-limit-instructions {
    padding: 8px 16px 16px 16px;
  }
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

// .modal-background {
//   position: fixed;
//   top: 0;
//   left: 0;
//   height: 100vh;
//   width: 100%;
//   z-index: 10;
//   font-family: $font-family;
//   backdrop-filter: grayscale(60%) blur(.75px);
// }

// dialog {
//   position: fixed;
//   top: 7vh;
//   left: 10%;
//   z-index: 100;
//   border-radius: 8px;
//   border: none;
//   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
//   padding: 0;
//   margin: 0;
//   max-height: 90vh;
//   max-width: 70em;
//   overflow: auto;
// }

// header {
//   text-align: left;
//   padding-left: 58px;
//   font-size: 12pt;
//   font-weight: 400;
//   color: #222;
//   // background: darken($color-sidebar, 2%);
//   width: 100%;
//   padding: 1rem;

// }

// section {
//   max-width: 100%;
//   padding: 1rem;
//   display: flex;
//   justify-content: left;
// }

// menu {
//   padding: 1rem;
//   display: flex;
//   justify-content: flex-end;
//   margin: 0;
// }

// @media (min-width: 200px) {
//   dialog {
//     top: 30%;
//     left: calc(25%);
//     width: 50%;
//   }
// }
// /*
//  * The following styles are auto-applied to elements with
//  * transition="modal" when their visibility is toggled
//  * by Vue.js.
//  *
//  * You can easily play with the modal transition by editing
//  * these styles.
//  */

// .modal-enter {
//   opacity: 0;
// }

// .modal-leave-active {
//   opacity: 0;
// }

// .modal-enter .modal-container,
// .modal-leave-active .modal-container {
//   -webkit-transform: scale(1.1);
//   transform: scale(1.1);
// }
</style>
